import React, { useRef } from 'react';

import { useSaveScrollPosition } from '../../../misc/useSaveScrollPosition';

export default props => {
    const {className = '', style, savePosition = location.pathname} = props,
        ref = useRef();

    useSaveScrollPosition(ref, savePosition);

    return (
        <div ref={ref} className={'scrollable ' + className} style={style}>
            {props.children}
        </div>
    );
};
